import React, { useEffect, useState, useCallback, useMemo, memo } from "react";
import { useParams } from "react-router-dom";
import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../MiddleWare/EncryptDecrypt/index.js";
import axiosInstance from "../../axios/axios";
import { AutoComplete, Checkbox } from "antd";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
import { BsCheckCircle } from "react-icons/bs";

const provider = localStorage.getItem("user_id")
  ? Decrypt_Value(localStorage.getItem("user_id"), "vozo")
  : "";

const IntakeForms = (props) => {
  const {
    toShow,
    toHide,
    patientName,
    patientMail = "",
    from,
    sendemailClick = () => {},
    addemailClick = () => {},
    refreshComp = () => {},
    patientId,
  } = props;
  const params = useParams();

  const doctype = "All";
  const specialty = "All";

  const [allIntakeForms, setAllIntakeForms] = useState([]);
  const [selectedIntakeForms, setSelectedIntakeForms] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(true);
  const [search, setSearch] = useState("");
  const [source, setSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ModalAlerShow, setModalAlerShow] = useState(false);
  const [ModalAlerShow1, setModalAlerShow1] = useState(false);
  const [ModalMsg, setModalMsg] = useState("");
  const [requireSign, setRequireSign] = useState(false);
  const [isManuallyClosed, setIsManuallyClosed] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const modClose1 = () => setModalAlerShow1(false);
  const modClose = () => setModalAlerShow(false);

  const handleModalHide = () => {
    setIsManuallyClosed(true);
    toHide();
  };

  const fetchTemplates = useCallback(async () => {
    setLoadingTemplates(true);
    setLoading(true);

    const query =
      "formname=" +
      "&doctype=" +
      doctype +
      "&speciality=" +
      specialty;

    try {
      const encrypted = Encrypt_Value(query, "vozo");
      const response = await axiosInstance.get(
        `/vozo/patient/templatelibrary/data?search=${encrypted}&notetype=1`,
      );

      const decrypted = Decrypt_Value(response.data, "vozo") || [];

      // Remove duplicates by ID
      const uniqueData = Array.from(
        new Map(decrypted.map((item) => [item.id, item])).values(),
      );

      setSource(uniqueData);
      setAllIntakeForms(uniqueData);

      setSelectedIntakeForms((prev) =>
        prev.length === 0
          ? uniqueData.filter((f) => f.intake_forms === 1)
          : prev,
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setLoadingTemplates(false);
    }
  }, []);

  useEffect(() => {
    if (toShow) {
      setSearch("");
      fetchTemplates();
    }
  }, [toShow, fetchTemplates]);

  const handleAddIntakeForm = (id) => {
    const selectedDoc = source.find((x) => x.id == id);
    if (!selectedDoc) return;

    setSelectedIntakeForms((prev) => {
      if (prev.some((f) => f.id === selectedDoc.id)) return prev;
      return [...prev, { ...selectedDoc, intake_forms: 1 }];
    });

    setSearch("");
  };

  const handleToggle = (id) => {
    setSelectedIntakeForms((prev) =>
      prev.map((f) =>
        f.id === id ? { ...f, intake_forms: f.intake_forms ? 0 : 1 } : f,
      ),
    );
  };

  const handleSendForms = async () => {
    setDisabled(true);
    const formsToSend = selectedIntakeForms.filter((f) => f.intake_forms === 1);

    if (formsToSend.length === 0) {
      setModalMsg("Please select at least one form");
      setModalAlerShow1(true);
      setTimeout(() => {
        setModalAlerShow1(false);
      }, 1000);
      return;
    }

    const RedefinedDocName = formsToSend.map((doc) => {
      // Skip if doc_name is null, undefined, or doesn't contain "-txt"
      if (!doc.doc_name || !doc.doc_name.includes("-txt")) {
        return doc.doc_name; // or return null, or return the original doc_name
      }

      const lastIndex = doc.doc_name.lastIndexOf("-txt");
      const randomNumber = Math.floor(Math.random() * 1001);
      const sanitized = doc.doc_name.replace(/[.,;]/g, "_");
      return (
        sanitized.slice(0, lastIndex) +
        `-${randomNumber}` +
        sanitized.slice(lastIndex)
      );
    });

    const article = {
      id: formsToSend.map((d) => d.id),
      file_path: formsToSend.map((d) => d.file_url),
      doc_name: RedefinedDocName,
      form_name: formsToSend.map(
        (d) => d.form_name + Math.floor(Math.random() * 1001),
      ),
      multi_select_number: "",
      editpatientshare: [patientId || params.pid],
      editpatsign: requireSign,
      patSelectAll: "No",
      uid: provider,
      type: "Template",
      reason: "",
      showInDocumentsTab: 1,
    };

    try {
      const encrypted = Encrypt_Value(article, "vozo");
      await axiosInstance.post(
        "/vozo/insertdocumenttemplate/patient",
        encrypted,
      );

      setModalMsg("Forms Sent Successfully!");
      setModalAlerShow(true);
      setDisabled(false);

      // Reset manual close flag
      setIsManuallyClosed(false);

      setTimeout(() => {
        setModalAlerShow(false);

        setTimeout(() => {
          // Only execute if modal wasn't manually closed
          if (!isManuallyClosed) {
            toHide();
            // if (from === "portal" || from === "create_client") {
            //   if (patientMail != "") {
            //     sendemailClick();
            //   } else {
            //     addemailClick();
            //   }
            // }
          }
        }, 500);
      }, 1500);
    } catch (err) {
      console.error(err);
      setModalMsg("Failed to Send Document");
      setModalAlerShow1(true);
    } finally {
      refreshComp();
    }
  };

  const handleSkipForNow = () => {
    toHide();
    // if (patientMail != "") {
    //   sendemailClick();
    // } else {
    //   addemailClick();
    // }
  };

  const autoCompleteOptions = useMemo(
    () =>
      source
        .filter((item) =>
          item.form_name.toLowerCase().includes(search.toLowerCase()),
        )
        .map((x) => ({
          value: String(x.id),
          label: <div className="toplabel">{x.form_name}</div>,
        })),
    [source, search],
  );

  return (
    <>
      <Modal
        className="up-doc-modal popup_centre"
        centered
        show={toShow}
        onHide={handleModalHide}
      >
        <Modal.Header closeButton>
          <div className="ed-doc-mod-title">
            Send {patientName} the following templates
          </div>
        </Modal.Header>

        <Modal.Body className="ed-doc-mod-body" id="cnst_frm-mod_bdy">
          {loadingTemplates ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <Spinner animation="border" />
              <div
                style={{ marginTop: "10px", fontSize: "14px", color: "#555" }}
              >
                Loading intake forms...
              </div>
            </div>
          ) : (
            <>
              <Form.Row className="c_f_u_d_f_r m-b-20">
                <Form.Group style={{ width: "100%" }}>
                  <div
                    className="for_autoComplete_bi"
                    style={{
                      width: "100% !important",
                      marginTop: "2px",
                      marginLeft: "-20px",
                    }}
                  >
                    <AiOutlineSearch />
                    <AutoComplete
                      virtual={false}
                      placeholder="Search documents"
                      className="remainderWidthSheet"
                      style={{ width: "99%" }}
                      value={search}
                      onSearch={setSearch}
                      onSelect={handleAddIntakeForm}
                      notFoundContent={
                        loading ? "loading..." : "No Result Found"
                      }
                      options={autoCompleteOptions}
                    />
                  </div>
                </Form.Group>
              </Form.Row>

              {selectedIntakeForms.map((item) => (
                <Form.Row className="c_f_u_d_f_r c_f_u_f_r_new" key={item.id}>
                  <Checkbox
                    className="con_form_upload_checkbox con_form_upload_checkbox_new"
                    checked={!!item.intake_forms}
                    onChange={() => handleToggle(item.id)}
                  />
                  <Form.Label
                    className="con_form_up_sign black_2e"
                    style={{
                      color: item.intake_forms
                        ? "rgba(51, 51, 51, 1)"
                        : "rgba(46, 46, 46, 0.25)",
                    }}
                  >
                    {item.form_name}
                  </Form.Label>
                </Form.Row>
              ))}
            </>
          )}
        </Modal.Body>

        <Modal.Footer className="intake-forms-request-sign">
          <Form.Row className="c_f_u_d_f_r c_f_u_f_r_new">
            <Checkbox
              className="con_form_upload_checkbox con_form_upload_checkbox_sign"
              checked={requireSign}
              onChange={(e) => setRequireSign(e.target.checked)}
            />
            <Form.Label className="con_form_up_sign con_form_up_sign_new black_2e">
              Require patient to Sign
            </Form.Label>
          </Form.Row>
          <div style={{ width: from === "documents" ? "90px" : "70px" }}>
            {""}
          </div>

          {from === "documents" ? (
            <>
              <Button
                className="close_active add_edit_con_form_cancel_btn"
                variant="light"
                onClick={toHide}
              >
                Cancel
              </Button>
              <Button
                className="save_active add_edit_con_form_upload_btn"
                variant="primary"
                onClick={handleSendForms}
                disabled={disabled}
              >
                Send
              </Button>
            </>
          ) : (
            <>
              <Button
                className="close_active add_edit_con_form_cancel_btn"
                variant="light"
                onClick={handleSkipForNow}
                style={{ width: "107px" }}
              >
                Skip for now
              </Button>
              <Button
                className="save_active add_edit_con_form_upload_btn"
                variant="primary"
                onClick={handleSendForms}
              >
                Send
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>

      <Modal
        className="alert-popup-message"
        show={ModalAlerShow1}
        onHide={modClose1}
      >
        <div className="alert msg alert-danger" role="alert">
          <IoCloseSharp className="icons-bs up-d-mod-mb" />
          <span className="up-d-mess-unsup">{ModalMsg}</span>
        </div>
      </Modal>

      <Modal
        className="alert-popup-message"
        show={ModalAlerShow}
        onHide={modClose}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {ModalMsg}
        </div>
      </Modal>
    </>
  );
};

export default memo(IntakeForms);
